import api from "../../../util/api";

const machine = "/interface/v1/vending-machine/";
const company = "/interface/v1/company/"

export default {
  async getCompany({ commit }, { id }) {
    try {
      const res = await api.get(company + id + '/feature_flags/');
      const data = await res.json();
      commit("show", { data });
      return data;
    } catch (err) {
      return err;
    }
  },
  async getMachine({ commit }, { id }) {
    try {
      const res = await api.get(machine + id + '/feature_flags/');
      const data = await res.json();
      commit("show", { data });
      return data;
    } catch (err) {
      return err;
    }
  }
};
